<template>
  <OArticleCard v-bind="$attrs" class="border border-[#E2E5ED] rounded-md bg-white">
    <template #desktop>
      <OArticleCover class="flex-shrink-0 rounded-t-md w-full" />
      <div class="p-2">
        <OArticleTitle class="hover:text-link-primary text-primary-100 text-sm font-semibold leading-16 block line-clamp-4" />
      </div>
    </template>
    <template #mobile>
      <OArticleCover class="w-full flex-shrink-0 rounded-t-md" />
      <OArticleVariant name="default">
        <div class="p-2">
          <OArticleTitle class="hover:text-link-primary text-primary-100 text-sm font-semibold leading-16 block line-clamp-4" />
        </div>
      </OArticleVariant>
      <OArticleVariant name="big">
        <div class="p-4">
          <OArticleTitle class="hover:text-link-primary text-primary-100 text-lg font-semibold block line-clamp-4" />
        </div>
      </OArticleVariant>
    </template>
  </OArticleCard>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';
import OArticleCard from '~/modules/card/components/ArticleCard';
import OArticleCover from '~/modules/card/components/ArticleCover';
import OArticleTitle from '~/modules/card/components/ArticleTitle';
import OArticleVariant from '~/modules/card/components/ArticleVariant';

export default defineComponent({
  components: {
    OArticleCard,
    OArticleCover,
    OArticleTitle,
    OArticleVariant,
  },
  inheritAttrs: false,
});
</script>
